export default __webpack_public_path__ + "static/media/daily-limit.6d1be11b.webp";